
import NavMenu from '../../components/navbar/NavMenu'
import TitleBar from '../../components/navbar/TitleBar'
import StopAddMain from '../../components/stops/StopsAddMain'
import Footer from '../../components/common/Footer'

export default function StopAddUpdatePage() {
    return (
        <>
            <TitleBar />
            <NavMenu />
            <StopAddMain />
            <Footer/>
        </>
    )
}
